import React, { useState } from 'react';
import styled from 'styled-components';
import useMe from '../../hooks/useMe';
import useFetch from '../../hooks/useFetch';
import useShipmentSnackbar from '../Shared/useShipmentSnackbar';
import { FaCheck, FaPencilAlt, FaTimes } from 'react-icons/fa';
import { LoadingIcon } from '@prosolve/common-components-ui';

const Card = styled.div``

const Header = styled.div`
  display: flex;
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 5px;
  gap: 10px;
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  color: #565656;
  font-size: 14px;
`

const Section = styled.div`
  display: flex;
  margin-bottom: 15px;
`

const SectionCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 150px;
  flex-grow: 1;
  padding-right: 15px;
`

const SmallLoadingIcon = styled.span`
  transform: scale(0.5) translate(-7px, -7px);
  height: 15px; 
  width: 15px;
`

// transform: scale(0.8); matches other icons, but is hard to see
const SmallFaPencilAlt = styled(FaPencilAlt)`
  transform: scale(1);
`

export default function ShippingNotes ({
  opportunity,
  onOpportunityUpdate
}) {
  const {
    Shipping_Notes__c
  } = opportunity;
  
  const { hasShipmentTrackingEdit: hasEdit } = useMe()

  const fetch = useFetch()
  const shipmentSnackbar = useShipmentSnackbar()

  const [isBusy, setIsBusy] = useState(false)
  const [isEditable, setIsEditable] = useState(false)
  const [shippingNotes, setShippingNotes] = useState(Shipping_Notes__c || '')

  const fetchSaveNotes = async () => {
    setIsBusy(true)
    try {
      const newOpp = {
        ...opportunity,
        Shipping_Notes__c: shippingNotes
      }
      await fetch('accounts/opportunity/updateNote', { 
        method: 'POST', 
        headers: { "Content-Type": "application/json" }, 
        body: JSON.stringify(newOpp) 
      })
      onOpportunityUpdate(newOpp)
    } catch (e) {
      shipmentSnackbar.newMessage({ message: 'Error ' + e, severity: 'failure' })
    }
    setIsBusy(false)
  }

  const editClick = () => {
    setIsEditable(true)
  }

  const saveClick = async () => {
    await fetchSaveNotes()
    setIsEditable(false)
    shipmentSnackbar.newMessage({ message: 'Notes saved', severity: 'success' })
  }

  const cancelClick = () => {
    setShippingNotes(Shipping_Notes__c)
    setIsEditable(false)
  }

  const notesChange = (e) => {
    setShippingNotes(e.target.value)
  }

  return (
    <Card>
      <Header>
        <span>{'Notes'}</span>
        <span style={{ display: 'flex', gap: '10px', alignItems: 'flex-end' }}>
          {hasEdit && <>
            {isBusy && <SmallLoadingIcon><LoadingIcon /></SmallLoadingIcon>}
            {!isBusy && <>
              {isEditable && <FaCheck title="Save Notes" style={{ cursor: 'pointer' }} onClick={saveClick} />}
              {isEditable && <FaTimes title="Cancel" style={{ cursor: 'pointer' }} onClick={cancelClick} />}
              {!isEditable && <SmallFaPencilAlt title="Edit Notes" style={{ cursor: 'pointer' }} onClick={editClick} />}
            </>}
          </>}
        </span>
      </Header>
      <Body>
        <Section>
          <SectionCol>
            {isEditable && !isBusy && <textarea rows={4} style={{ width: '100%' }} onChange={notesChange} value={shippingNotes} />}
            {(!isEditable || isBusy) && <span>{shippingNotes}</span>}
          </SectionCol>
        </Section>
      </Body>
    </Card>
  )
}